import { PRODUCTS } from '..';


export const LOBBY_TYPES = {
  [PRODUCTS.casino]: 'classic-casino',
  [PRODUCTS.liveCasino]: 'live-casino',
  [PRODUCTS.virtuals]: 'virtual-sports'
};

export const REALITY_CHECK_VALUES = [5, 10, 15, 30, 60];

export const GAME_NOT_FOUND_ERROR = 'GAME_NOT_FOUND';
